import { FC } from 'react';
import { useParams } from 'react-router-dom-v5-compat';

import InactiveEnvironmentBanner from 'dashboard/components/InactiveEnvironmentBanner';
import NavBack from 'dashboard/components/NavBack';
import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import IntegrationLog from 'dashboard/modules/IntegrationLog';

type Params = { integrationLogId: string };
const DashboardIntegrationLogsView: FC = () => {
  const { integrationLogId } = useParams<Params>() as Params; // integrationLogId will always be defined

  return (
    <>
      <InactiveEnvironmentBanner />
      <Container>
        <Header
          title={`Integration Logs - ${integrationLogId}`}
          prepend={<NavBack to='/dashboard/integration-logs' />}
        />
        <Section>
          <IntegrationLog token={integrationLogId} />
        </Section>
      </Container>
    </>
  );
};

export default DashboardIntegrationLogsView;
